import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';

import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription, finalize } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';

import { PetServices } from '../../../../services/petservices';
import { CartService } from '../../../../services/cart';

@Component({
  selector: 'app-clinicservice',
  templateUrl: './clinicservice.component.html',
  styleUrl: './clinicservice.component.scss'
})
export class ClinicserviceComponent implements OnInit, OnDestroy {
  service: any = null;

  isLoading = false;
  isAr = false;
  quantity = 0;

  private isBrowser: boolean;
  private langSub?: Subscription;
  private routeSub?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private petServices: PetServices,
    private cartService: CartService,
    private transloco: TranslocoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.isAr = this.transloco.getActiveLang() === 'ar';

    this.langSub = this.transloco.langChanges$.subscribe(lang => {
      this.isAr = lang === 'ar';
    });

    this.routeSub = this.route.params.subscribe(params => {
      const id = Number(params['id']);

      if (!id) return;

      this.loadService(id);

      if (this.isBrowser) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
    this.routeSub?.unsubscribe();
  }

  loadService(id: number): void {
    this.isLoading = true;

    this.petServices.getById(id)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: (res: any) => {
          this.service = res?.data ?? res;

          if (this.isBrowser && this.service?.id) {
            this.quantity = this.cartService.getProductQuantity(this.service.id);
          }
        },
        error: err => {
          console.error('Failed to load clinic service', err);
          this.service = null;
        }
      });
  }

  plus(): void {
    if (!this.service) return;

    const item = this.prepareServiceItem();
    this.cartService.addToCart(item);
    this.quantity = this.cartService.getProductQuantity(this.service.id);
  }

  min(): void {
    if (!this.service) return;

    const currentQty = this.cartService.getProductQuantity(this.service.id);

    if (currentQty > 0) {
      this.cartService.removeFromCart(this.prepareServiceItem());
      this.quantity = this.cartService.getProductQuantity(this.service.id);
    }
  }

  private prepareServiceItem(): any {
    return {
      ...this.service,
      quantity: 1,
      is_service: true,
      type: 'clinic_service'
    };
  }

  calcDis(newP: any, oldP: any): number {
    const newPrice = Number(newP);
    const oldPrice = Number(oldP);

    if (!newPrice || !oldPrice || oldPrice <= newPrice) {
      return 0;
    }

    return Math.round(((oldPrice - newPrice) / oldPrice) * 100);
  }

  getServicePrice(): number {
    return Number(this.service?.price ?? 0);
  }

  fixImage(url: any): string {
    if (!url) return '';

    if (url.startsWith('http')) {
      return url;
    }

    return 'https://backendproduction.blueboxpet.com/storage/app/public/' + url;
  }

  getFallbackImage(): string {
    if (this.service?.pet === '0' || this.service?.pet_type === '0') {
      return '/assets/noproduct cat.webp';
    }

    return '/assets/noproduct dog.png';
  }
}